import { render } from "./MatchContent2UEFA.vue?vue&type=template&id=57904e84&scoped=true"
import script from "./MatchContent2UEFA.vue?vue&type=script&lang=js"
export * from "./MatchContent2UEFA.vue?vue&type=script&lang=js"

import "./MatchContent2UEFA.vue?vue&type=style&index=0&id=57904e84&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57904e84"]])

export default __exports__